module.exports = __webpack_public_path__ + "img/32.9dd2035f.png";